<template>
<div>
    <el-button
      @click="daochu"
      type="primary"
      style="background: #f78989; border-color: #f78989; margin-bottom: 20px"
      >导出</el-button
    >
    <el-table
    :data="list"
    stripe
    border
    style="width: 100%">
    <el-table-column
      prop="desc"
      label="中文描述"
    >
    </el-table-column>
    <el-table-column
      prop="code"
      label="产品名称"
     >
    </el-table-column>
    <el-table-column
      prop="caseNum"
      label="箱件数">
    </el-table-column>
        <el-table-column
      prop="caseNum"
      label="箱数">
    </el-table-column>
        <el-table-column
      prop="num"
      label="数量">
    </el-table-column>
        <el-table-column
      prop="totalWeight"
      label="总重量/吨">
    </el-table-column>
        <el-table-column
      prop="price"
      label="单价/元">
    </el-table-column>
        <el-table-column
      prop="amount"
      label="销售金额/元">
    </el-table-column>
        <el-table-column
   
      label="是否整箱">


       <template #default="scope">
  {{ scope.row.ifFull=='Y'?'是':'否' }}
      </template>
    </el-table-column>
    
  

  
  </el-table>
</div>
</template>

<script>
  export default {
    created(){
     let deliverySeq=this.$route.params.id
   
           this.$axios
        .postReq("/meide/REST/ajaxOrderReport", {
          postType: "queryDeliveryDetail",
          deliverySeq
      
        }).then(res=>{
       
         this.list=res.data
        })
    },
    methods:{
          daochu() {
      let deliverySeq=this.$route.params.id
      this.$axios
        .postReq("/meide/REST/ajaxOrderExport", {
          postType: "exportDeliveryDetail",
          deliverySeq,
        })
        .then((res) => {
          if (res.success == "true") {
            let url = res.url;
            window.open(url);
          } else {
            // this.$message.error(res.ErrorText);
          }
        });
    },
    },
    data() {
      return {
     list:[]
      }
    }
  }
</script>